<template>
  <div class="contaier">
    <div class="form-box">
      <!-- <div class="title xl:text-3xl md:text-2xl text-2xl font-semibold">
        {{ $t("home.form_title") }}
      </div> -->
      <div
        class="title xl:text-3xl md:text-2xl text-2xl md:pb-[30px] pb-[20px] font-semibold"
      >
        {{ $t("home.form_title2") }}
      </div>
      <p class="note text-10px pb-[10px]" id="myElement">
        {{ $t("home.mandatory") }}
      </p>
      <el-form
        :model="form"
        ref="formRef"
        :rules="formRules"
        label-width="80px"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :md="4" :sm="6" :xs="8">
            <el-form-item :label="$t('home.appellation')" prop="title">
              <el-select
                style="width: 100%"
                :value="form.title"
                @change="changeTitle"
                :placeholder="$t('home.selectAppellation')"
              >
                <el-option
                  :label="$t('appellation.Sir')"
                  :value="$t('appellation.Sir')"
                ></el-option>
                <el-option
                  :label="$t('appellation.lady')"
                  :value="$t('appellation.lady')"
                ></el-option>
                <el-option
                  :label="$t('appellation.Miss')"
                  :value="$t('appellation.Miss')"
                ></el-option>
                <el-option
                  :label="$t('appellation.PhD')"
                  :value="$t('appellation.PhD')"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="10" :sm="18" :xs="16">
            <el-form-item :label="$t('home.lastName')" prop="lastName">
              <el-input
                v-model="form.lastName"
                :placeholder="$t('home.enterLastName')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="10" :sm="24">
            <el-form-item :label="$t('home.firstName')" prop="firstName">
              <el-input
                v-model="form.firstName"
                :placeholder="$t('home.enterFirstName')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('home.mobileNumber')" prop="phone">
              <div class="phone-box">
                <div class="phone-sum">+852</div>
                <div class="phone-">
                  <el-input
                    v-model="form.phone"
                    :placeholder="$t('home.enterPhone')"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('home.emailAddress')" prop="email">
              <el-input
                v-model="form.email"
                :placeholder="$t('home.enterEmail')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- class="hidden-xs-only" -->
        <el-row :gutter="20">
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('carOption.cartitle')" prop="carModel">
              <el-select
                style="width: 100%"
                :value="form.carModel"
                @change="changeCar"
                :placeholder="$t('carOption.carModel_')"
              >
                <el-option label="V27" value="V27"></el-option>
                <!-- <el-option label="V27 Sport (AWD)" value="V27 Sport (AWD)"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('home.selectLanguage')" prop="language">
              <el-select
                style="width: 100%"
                :value="form.language"
                @change="changeLan"
                :placeholder="$t('home.pleaseSelectLanguage')"
              >
                <el-option
                  :label="$t('home.lang_en')"
                  :value="$t('home.lang_en')"
                ></el-option>
                <el-option
                  :label="$t('home.lang_cn')"
                  :value="$t('home.lang_cn')"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-form-item :label="$t('home.corporateClient')" prop="enterprise">
          <el-radio-group v-model="form.enterprise">
            <el-radio :label="$t('home.yes')"></el-radio>
            <el-radio :label="$t('home.no')"></el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- <el-form-item
          :label="$t('home.corporateClient')"
          prop="enterprise"
          class="hidden-sm-and-up"
        >
          <el-radio-group v-model="form.enterprise">
            <el-radio :label="$t('home.yes')"></el-radio>
            <el-radio :label="$t('home.no')"></el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- <el-form-item
          v-if="form.enterprise === '是' || form.enterprise === 'Yes'"
          :label="$t('home.pleaseWriteName_')"
          prop="enterpriseUser"
          :rules="[
            {
              required: form.enterprise == '是' || form.enterprise === 'Yes',
              message: $t('home.pleaseWriteName'),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.enterpriseUser"
            :placeholder="$t('home.pleaseWriteName')"
          ></el-input>
        </el-form-item> -->

        <!-- <el-form-item :label="$t('home.remark')">
          <el-input v-model="form.remark"></el-input>
        </el-form-item> -->
        <el-form-item prop="agreePrivacy">
          <el-checkbox-group style="width: 100%" v-model="form.agreePrivacy">
            <el-checkbox name="agreePrivacy" :label="true">
              {{ $t("home.agree_") }}
              <a class="to-page" @click="goNewPage">{{ $t("home.policy_") }}</a>
              {{ $t("home.and")
              }}<a class="to-page" @click="goNewPage1">{{ $t("home.statement_") }}</a>
              {{ $t("home.fullStop") }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>

        <el-form-item>
          <el-checkbox-group style="width: 100%" v-model="form.agreeUsePersonal">
            <el-checkbox name="agreeUsePersonal" :label="true">{{
              $t("home.privacyPolicy")
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <div class="btn" @click="submitForm">{{ $t("home.submit") }}</div>
      </div>
    </div>

    <!-- <el-dialog
      top="35vh"
      width="190px"
      :show-close="false"
      :visible.sync="dialogVisible"
      custom-class="custom-class-dialog1"
    >
      <div class="dialog-box">
        <i class="el-icon-check icon-check"></i>
        <div class="title">{{ $t("home.InformationSubmitted") }}</div>
      </div>
    </el-dialog> -->

    <el-dialog
      top="35vh"
      width="190px"
      :show-close="false"
      :visible.sync="dialogVisible2"
    >
      <div class="dialog-box dialog-box2">
        <i class="el-icon-loading icon-check"></i>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { addIcaurCusApi } from "@/Api/requestApi";
export default {
  name: "FormPage",
  data() {
    let validateTitle = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("home.selectAppellation")));
      }
      callback();
    };
    let enterLastName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("home.enterLastName")));
      }
      callback();
    };
    let enterFirstName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("home.enterFirstName")));
      }
      callback();
    };
    let pleaseSelectLanguage = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("home.pleaseSelectLanguage")));
      }
      callback();
    };

    // let Postcode = (postcode) => {
    //   const regex = /^[0-9][0-9]{5}$/;
    //   return valid(postcode, regex, "請輸入正確的郵箱！");
    // };
    let Postcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("home.enterEmail")));
      }
      const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!regExp.test(value)) {
        return callback(new Error(this.$t("home.rightEmail")));
      } else {
        callback();
      }
    };
    let phonecode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("home.enterPhone")));
      }
      const regExp = /^(4|5|6|7|8|9)\d{7}$/;
      if (!regExp.test(value)) {
        return callback(new Error(this.$t("home.rightPhone")));
      } else {
        callback();
      }
    };

    // let carModelCode = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t("carOption.carModel_")));
    //   }
    //   callback();
    // };

    // let corporateClient_ = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t("home.corporateClient_")));
    //   }
    //   callback();
    // };

    let _policy = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error(this.$t("home._policy")));
      }
      callback();
    };

    return {
      dialogVisible: false,
      dialogVisible2: false,
      // dialogVisible1: false,

      form: {
        title: "",
        lastName: "",
        firstName: "",
        phone: "",
        email: "",
        remark: "",
        language: this.$i18n.locale === "zh" ? "英文" : "English",
        carModel: "V27",
        enterprise: "", //我加的
        enterpriseUser: "",
        carReplace: "",
        agreePrivacy: [],
        agreeUsePersonal: [],
      },

      formRules: {
        title: [{ required: true, validator: validateTitle, trigger: "change" }],
        lastName: [{ required: true, validator: enterLastName, trigger: "blur" }],
        firstName: [{ required: true, validator: enterFirstName, trigger: "blur" }],
        language: [
          {
            required: true,
            validator: pleaseSelectLanguage,
            trigger: "change",
          },
        ],
        phone: [{ required: true, validator: phonecode, trigger: "change" }],
        email: [{ required: true, validator: Postcode, trigger: "change" }],
        // carModel: [{ required: true, validator: carModelCode, trigger: "change" }],
        // enterprise: [{ required: true, validator: corporateClient_, trigger: "blur" }],

        agreePrivacy: [
          {
            type: "array",
            // required: true,
            validator: _policy,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      // this.dialogVisible = true;
      // this.dialogVisible2 = true;
      let _lang = window.sessionStorage.getItem("sessionLang") || "zh";
      // this.$router.push({ path: "/succeed", query: { lang: _lang } });
      // this.$router.push({ path: "/succeed" });
      // return;
      this.$refs.formRef.validate(async (valid) => {
        // console.log("valid :>> ", valid);
        if (valid) {
          let formDate_ = cloneDeep(this.form);

          formDate_.phone = `852 ${formDate_.phone}`;

          // console.log("form :>>通过了 11", this.form);
          // return;

          formDate_.agreePrivacy = formDate_.agreePrivacy[0];
          formDate_.agreeUsePersonal = formDate_.agreeUsePersonal[0];
          delete formDate_.enterprise;
          // formDate_.agreePrivacy = formDate_.agreePrivacy.join("");
          // formDate_.agreeUsePersonal = formDate_.agreeUsePersonal.join("");

          console.log("form :>>通过了 ", formDate_);
          this.dialogVisible2 = true;
          // return;
          const {
            data: { code },
          } = await addIcaurCusApi(formDate_);

          if (code === 200) {
            // this.dialogVisible = true;
            this.form = {
              title: "",
              lastName: "",
              firstName: "",
              phone: "",
              email: "",
              remark: "",
              language: this.$i18n.locale === "zh" ? "英文" : "English",
              carModel: "V27",
              enterpriseUser: "",
              carReplace: "",
              agreePrivacy: [],
              agreeUsePersonal: [],
            };
            this.$refs.formRef.resetFields();
            setTimeout(() => {
              // this.dialogVisible = false;
              this.dialogVisible2 = false;
              // this.$router.push({ path: "/succeed" });
              this.$router.push({ path: "/succeed", query: { lang: _lang } });
            }, 1200);
          }
        } else {
          document.getElementById("myElement")?.scrollIntoView();
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.formRef.resetFields();
    },
    goNewPage() {
      window.open("https://www.kamlung.com/privacy-policy?lang=tc", "_blank");
    },
    goNewPage1() {
      window.open("https://www.kamlung.com/copy-of-privacy-policy?lang=tc", "_blank");
    },
    // _______________________
    openForm() {
      this.dialogVisible = true;
    },
    // openForm2() {
    //   this.dialogVisible1 = true;
    // },
    // ---------------------------
    downloadPDF() {
      const link = document.createElement("a");
      link.href = "https://ssy.kamlung.net/excel/pv5.pdf";
      link.download = "filename.pdf";
      link.target = "_blank";
      link.click();
      // document.body.removeChild(link);
    },
    changeLanguage(e) {
      // console.log("validateTitle :>> ", validateTitle);
      this.$refs.formRef.resetFields();

      if (e === "en") {
        console.log("e :>>2211 ", e);
        this.form.language = this.form.language === "繁體中文" ? "繁體中文" : "英文";
      } else {
        console.log("e :>>2222 ", e);
        // console.log("999999999 ", this.form.language);
        this.form.language = this.form.language === "繁體中文" ? "Chinese" : "English";
      }
      // this.$refs.formRef.validate((valid) => {
      //   console.log("没通过 :>>1 ");
      //   if (!valid) {
      //     console.log("没通过 :>>2 ");
      //   }
      // });
    },
    changeTitle(v) {
      console.log("v :>>changeTitle ", v);
      this.form.title = v;
    },
    changeCar(v) {
      console.log("v :>>changeTitle ", v);
      this.form.carModel = v;
    },
    changeLan(v) {
      console.log("v :>>changeTitle ", v);
      this.form.language = v;
    },
  },
};
</script>

<style lang="scss">
.row-expand-cover td .el-table__expand-icon {
  visibility: hidden;
}

.custom-class-dialog1 {
  background-color: #f56c6c;
  .el-dialog__body {
    padding: 22px 15px 48px 15px !important;
  }
}

input[aria-hidden="true"] {
  display: none !important;
}
.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}
</style>

<style lang="scss" scoped>
@import "element-ui/lib/theme-chalk/display.css";

.el-form-item {
  margin-bottom: 26px !important;
}

@media (min-width: 400px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
}

@media (max-width: 768px) {
  /* 平板样式 */
}
@media (max-width: 1024px) {
  /* 桌面样式 */
}

@media (max-width: 470px) {
  .img-bg {
    aspect-ratio: 3 / 9;
  }
}
@media (max-width: 440px) {
  .img-bg {
    aspect-ratio: 3 / 10;
  }
}
@media (max-width: 390px) {
  .img-bg {
    aspect-ratio: 3 / 12;
  }
}

.contaier {
  padding: 30px 0;
  background-color: #fff;

  ::v-deep .el-dialog {
    border-radius: 10px !important;
    background: none !important;
    background-color: rgba(000, 000, 000, 0.6) !important;
  }

  [aria-hidden="true"] {
    display: none !important;
  }
  .form-box {
    // padding: 30px;
    // border-radius: 5px;
    .title {
      font-family: "icaurFontBold", sans-serif;
    }

    width: 92%;
    margin: 0 auto;
    max-width: 1000px;
    .phone-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .phone-sum {
        width: 66px;
        // padding-top: 10px;
        font-size: 1.1rem !important ;
        // line-height: 1.2rem !important;
        font-weight: 400;
      }
      .phone- {
        flex: 1;
      }
    }
    .note {
      color: #999;
    }
    .note:before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
    ::v-deep .el-input {
      font-size: 1.05rem !important ;
    }
    ::v-deep .el-form-item__label {
      font-size: 1.15rem !important ;
      line-height: 1.6rem !important;
      font-weight: 400;
    }
    ::v-deep .el-radio__label {
      font-size: 1.15rem !important ;
      // line-height: 1.2rem !important;
      font-weight: 400;
    }
    ::v-deep .el-radio {
      // margin-right: 72px !important ;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-right: 30px !important;
    }

    ::v-deep .el-radio__inner {
      border-color: #000 !important ;
      transform: scale(1.5);
    }

    ::v-deep .el-radio-group {
      padding-left: 4px !important ;
    }

    ::v-deep .el-checkbox__inner {
      border-color: #000 !important ;
      // background-color: #000 !important ;
      transform: scale(1.5);
      // width: 22px !important;
      // height: 22px !important;
    }

    ::v-deep .el-checkbox__label {
      font-size: 1.05rem !important ;
      line-height: 1.6rem !important;
      padding-left: 15px !important;
      white-space: pre-wrap;
      color: #000;
      // line-height
      font-weight: 400;
    }

    ::v-deep .el-checkbox-group {
      padding-left: 4px !important;
    }
    ::v-deep .el-radio__input.is-checked + .el-radio__label {
      color: #000 !important;
    }
    ::v-deep .el-radio__input.is-checked .el-radio__inner {
      background: #000 !important ;
    }

    ::v-deep .is-checked .el-checkbox__inner {
      background-color: #000 !important ;
      // border-color: #409EFF;
    }

    .checkbox-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .checkbox- {
        width: 20px;
      }
      .text {
        padding-left: 10px;
        flex: 1;
        font-size: 1.1rem !important ;
        line-height: 1.8rem !important;
        font-weight: 400;
      }
    }
    .to-page {
      cursor: pointer;
      text-decoration: underline;
    }

    ::v-deep .el-input__inner {
      border: none !important;
      border-radius: 0 !important;
      border-bottom: #666 1px solid !important;
    }

    // ::v-deep .el-textarea__inner {
    //   border: none !important;
    //   border-radius: 0 !important;
    //   border-bottom: #666 1px solid !important;
    // }

    ::v-deep .is-error .el-input__inner {
      border-bottom: #f56c6c 2px solid !important;
    }
    .el-checkbox {
      display: flex !important;
      // justify-content: space-between;
      align-items: center;
    }
  }
  .btn-box {
    padding-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    .btn {
      width: 200px;
      line-height: 40px;
      border-radius: 20px;
      background-color: #000;
      cursor: pointer;
      color: #fff;
    }
  }
}
::v-deep.el-select-dropdown__item {
  font-size: 1.1rem !important ;
  // line-height: 1.2rem !important;
  font-weight: 400;
}

.dialog-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .icon-check {
    font-size: 60px;
    font-weight: 600;
    color: #fff;
  }
  .title {
    padding-top: 10px;
    font-size: 16px;
    color: #fff;
  }
}
.dialog-box2 {
  padding-top: 5px;
  padding-bottom: 30px;
}
.dialog-box1 {
  .iframe {
    // white: 100%;
  }
}
</style>
